import React, { useCallback } from 'react';
import { createFormField } from 'Shared/utils/createFormField';
import cn from 'classnames';

type Props = {
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value: string;
  placeholder: string;
  rows?: number;
  maxLength?: number;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  fastBlur?: boolean;
  touched: boolean;
  error: string;
  errorLabel?: boolean;
  textareaClassName?: string;
  resize: string;
};

function TextArea({
  className,
  onChange,
  value,
  placeholder,
  rows = 2,
  maxLength = null,
  onFocus,
  onBlur,
  fastBlur = false,
  touched,
  error,
  errorLabel = true,
  textareaClassName,
}: Props) {
  const handleChange = useCallback(
    values => {
      onChange(values);
      if (onFocus) setTimeout(onFocus);
      if (onBlur && fastBlur) setTimeout(onBlur);
    },
    [fastBlur, onBlur, onChange, onFocus]
  );

  return (
    <div className={cn('w-100 form-group', className)}>
      <textarea
        className={cn('form-control w-100', textareaClassName, { 'is-invalid': touched && error })}
        placeholder={placeholder}
        value={value}
        rows={rows}
        maxLength={maxLength}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {touched && error && errorLabel ? <p className="form-input-error text-danger">{error}</p> : null}
    </div>
  );
}

export default createFormField(TextArea);
